import AsyncStatus from 'mini-common-schema/lib/schema/AsyncStatus';
import executeSearchService from 'mini-execute-mail-search-service/lib/services/executeSearchService';
import isItemView from 'mini-mail-list-store/lib/utils/isItemView';
import ItemTypesFilter from 'owa-service/lib/contract/ItemTypesFilter';
import SearchTableQuery from 'mini-mail-list-store/lib/store/schema/SearchTableQuery';
import { getMailSearchResultsFromExecuteSearchResponse } from './getMailSearchResultsFromResponse';
import { MAIL_QUERY_PAGE_SIZE } from 'mini-3s-service/lib/utils/constants';
import { MailSearchResults } from '../store/schema/MailSearchResults';

/**
 * Returns a promise which resolves when executeSearch service completes.
 * An object containing the mail results are returned when the promise resolves.
 * @param searchTableQuery
 */
export const getExecuteSearchResults = (
    searchTableQuery: SearchTableQuery
): Promise<MailSearchResults> => {
    const itemTypes: ItemTypesFilter = isItemView() ? 'MailItems' : 'MailConversations';

    const { queryString, rowOffset, searchSessionGuid, searchFolderScopeId } =
        searchTableQuery ?? {};

    return executeSearchService({
        rowOffset: rowOffset,
        pageSize: MAIL_QUERY_PAGE_SIZE,
        queryString: queryString,
        sessionGuid: searchSessionGuid,
        staticFolderScopeId: searchFolderScopeId,
        itemTypes,
    })
        .then(response => getMailSearchResultsFromExecuteSearchResponse(response?.Body, itemTypes))
        .catch(error => ({
            asyncStatus: error.networkError ? AsyncStatus.Error : AsyncStatus.ServerError,
            areMoreResultsAvailable: false,
            rows: [],
        }));
};
